<template>

    <div v-if="server_teamStatus_c && server_questBody_c"
         class="lc_root TQ_center TQ_height_100p ">

       <!-- 1) laeflet -->
        <tq-leaflet-display
                :key="refreshMapCounter_n + displayLangForMap_e"
                class="TQ_height_bodyFullScreen"

                :pb_map-uid_s="$options.name"
                :p_display_lang-code_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_v.val)"

                :p_map-data_c="server_questBody_c.qb_mapData_c"
                :p_polygons_ac="server_questBody_c.qb_mapData_c.md_polygons_ac"

                :p_players-location_by-user-id_c="server_mapPlayersLocations_byUserId_c"
                :p_current-user-location_c="co_getCurrentUserLocation_c"

                :p_missions_ac="server_questBody_c.qb_mapMissions_ac"
                :p_mission-groups_ac="server_questBody_c.qb_mapMissionsGroup_ac"
                :p_finish-missions-indexes_an="co_getFinishMissionIndex_an"
                :p_map-mission-type_e="server_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e"
                :p_map-type_e="server_questBody_c.qb_metadata_c.qbm_mapMissions_mapType2_e"

                :p_background-image_s="server_questBody_c.qb_theme_c.qbt_backgroundImg_s"
                :p_show-zoom-control_b="server_questBody_c.qb_metadata_c.qbm_mapMissions_showZoomControl_b"
                :p_show-gps-btn_b="server_questBody_c.qb_metadata_c.qbm_mapMissions_showGpsBtn_b"
                :p_right-zoom-btns_b="server_questBody_c.qb_metadata_c.qbm_mapMissions_rightZoomBtns_b"

                :pe_click-polygon_f="m_clickPolygon_f"
                :pe_on-click-mission_f="m_click_riddle_f"
                :pe_start-watch-position_f="pe_startWatchPosition_f"
                :pe_stop-watch-position_f="pe_stopWatchPosition_f"
        />

        <!-- 2) more buttons -->
        <div class="lc_finishRiddle TQ_direction_ltr TQ_clickable" :style="{'zIndex' : gv_zIndex.ongoing_map_btns}">
            <tq-card padding="6px 4px 2px 6px"
                     v-if="server_questBody_c.qb_metadata_c.qbm_quest_supportMapLastMissions_b"
                     @click.native="m_click_lastRiddles_f()">
                <img :src="ass_img_puzzle" class="TQ_width_40px"/>
            </tq-card>

            <tq-card padding="6px 4px 2px 6px" margin="0 5px"
                     v-if="server_questBody_c.qb_metadata_c.qbm_quest_hiddenCodesMode_e > enum_supportClueCodeTypes.e_none_n"
                     @click.native="showSearchClue_vb.val=true">
                <img :src="ass_img_searchIdea" class="TQ_width_40px"/>
            </tq-card>
        </div>

        <!-- 3) enter clueCode popup-->
        <tq-popup :show="showSearchClue_vb" width="100%" margin="16px" padding="0px" maxWidth="300px" class="TQ_center" :show-close-btn="true">

            <!-- title -->
            <div class="TQ_text_24px TQ_text_bold TQ_bg_purple_dark TQ_padding_8px">{{ ass_strings.threeWords_enterHiddenCode[store_system_langCode_v.val] }}</div>

            <!-- enter clue code -->
            <tq-input-fast-delete
                class="TQ_padding_16px TQ_border_bottom_gray"
                deleteImgClass="TQ_img TQ_img_19px"
                :inputPlaceholder=ass_strings.oneWord_code[store_system_langCode_v.val]
                inputClass="TQ_input TQ_input_big TQ_text_20px TQ_width_100p TQ_borderBox"
                :update-text="(text) => {userClueCode_s = text}"
            />

            <div class="TQ_padding_8px TQ_text_20px TQ_align_end">
                <div class="TQ_padding_4px TQ_bg_purple TQ_width_80px TQ_borderRadius TQ_inline TQ_center TQ_box_shadow TQ_clickable" @click="m_checkClueCode_f()">
                    {{ass_strings.oneWord_approve[store_system_langCode_v.val]}}
                </div>
            </div>
        </tq-popup>

    </div>
    <div v-else class="TQ_center">
        <ball-pulse-sync-loader color="#2E294E" size="10px"/>
    </div>
</template>

<script>

    import {store_var, store_getStateValue_vo} from "../../../store";
    import {
        enum_mapMissionsTypes,
        enum_mapTypes,
        enum_subCollection_teamStatus, enum_hiddenCodesTypes
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {route_moveToRoute} from "../../../router";
    import {notification_notify} from "../../../scripts/S_Notification";
    import {
        serverOngoing_teamPlayersGeoLocation_cl_set_f,
        serverOngoing_teamPlayersGeoLocation_cl_remove_f,
        serverOngoing_teamStatus_subCollection_cl_get_f, serverOngoing_teamStatus_subCollection_cl_remove_f,
        serverOngoing_hiddenClue_update_f,
        serverOngoing_teamStatus_vl_set_f,
        serverOngoing_teamStatus_vl_remove_f
    } from "../../../scripts/Server/S_ServerOngoing";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";

    import TqLoaderContainer from "../../../components/basic/TqLoaderContainer";
    import TqCard from "../../../components/basic/TqCard";
    import TqPopup from "../../../components/basic/TqPopup";
    import TqInputFastDelete from "../../../components/basic2/TqInputFastDelete";
    import {
        serverAuth_getOtherUserData_f} from "../../../scripts/Server/S_ServerAuth";
    import {helper_finishRiddle_fb, helper_getFinishRiddlesIds_fan} from "../../../scripts/S_Helper";
    import {serverBig_questBody_once_fp} from "../../../scripts/Server/S_ServerFirestore";
    import {
        ass_img_myLocation_blue,
        ass_img_myLocation_gray,
        ass_img_puzzle_c,
        ass_img_searchIdea
    } from "../../../assets/scripts/Ass_Files";
    import {gv_zIndex} from "../../../scripts/S_GlobalVar";
    import {
        enum_moveToOptions,
        enum_urlParams
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import TqGoogleMap from "../../../components/maps/TqGoogleMap";
    import TqLeafletDisplay from "../../../components/maps/TqLeafletDisplay";
    import TqBtnApprove from "../../../components/basic2/TqBtnApprove";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f
    } from "../../../scripts/Server/S_ServerAuth";
    import {FB_MapPlayerLocation} from "@/classes/client_classes";

    export default {
        name: "V_Ongoing_Quest_openMap_Map",
        components: {
            TqBtnApprove,
            TqLeafletDisplay,
            TqGoogleMap,
            TqInputFastDelete,
            TqPopup,
            TqCard,
            TqLoaderContainer,
        },
        props:{
            pe_startWatchPosition_f:{
                type: Function,
                require: true
            },
            pe_stopWatchPosition_f:{
                type: Function,
                require: true
            }
        },
        data(){
            return {

                showSearchClue_vb   : {val : false},
                userClueCode_s      : '',
                refreshMapCounter_n : 0,
                displayLangForMap_e : '',

                // store
                store_ongoing_questEvent_v              : store_getStateValue_vo(store_var.ongoing_questEvent),
                store_currentTeamId_uid                 : store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val,
                store_system_langCode_v                 : store_getStateValue_vo(store_var.system_langCode),
                store_currentUserGeoLocation_vc         : store_getStateValue_vo(store_var.system_currentUserLocation),

                //server
                server_mapPlayersLocations_byUserId_c : {},
                server_teamsPlayersData_byPlayerIdC : {},
                server_currentUserData_c            : undefined,
                server_questBody_c                  : undefined,
                server_teamStatus_c                 : undefined,
                store_ongoing_teamStatus_riddles_byRiddleId_c : {},

                // assents
                ass_strings                 : ass_strings,
                ass_img_searchIdea          : ass_img_searchIdea,
                ass_img_puzzle              : ass_img_puzzle_c,
                ass_img_myLocation_blue     : ass_img_myLocation_blue,
                ass_img_myLocation_gray     : ass_img_myLocation_gray,
                enum_mapTypes               : enum_mapTypes,
                enum_supportClueCodeTypes   : enum_hiddenCodesTypes,
                gv_zIndex                   : gv_zIndex
            }
        },
        computed:{
            co_getFinishRiddlesIds_an(){

                if(this.server_questBody_c == null){
                    return []
                }

                return helper_getFinishRiddlesIds_fan(
                    this.store_ongoing_teamStatus_riddles_byRiddleId_c,
                    this.server_questBody_c.qb_mapMissions_ac)
            },
            co_getFinishMissionIndex_an(){

                let ans = []

                this.server_questBody_c.qb_mapMissions_ac.forEach((qb_riddle_c, riddleIndex) => {
                    if(helper_finishRiddle_fb(qb_riddle_c, this.store_ongoing_teamStatus_riddles_byRiddleId_c[qb_riddle_c.qbr_riddleId_n])){
                        ans.push(riddleIndex)
                    }
                })

                return ans
            },
            co_getCurrentUserLocation_c(){

                if(this.server_currentUserData_c == null || this.store_currentUserGeoLocation_vc.val == null){
                    return null
                }

                return new FB_MapPlayerLocation({
                    mpl_userId_uid      : this.server_currentUserData_c.ud_userId_uid,
                    mpl_username_s      : null,
                    mpl_dotColor_s      : "#4285F4",
                    mpl_accuracy_n      : this.store_currentUserGeoLocation_vc.val.ugl_accuracy_n,
                    mpl_latitude_n      : this.store_currentUserGeoLocation_vc.val.ugl_latitude_n,
                    mpl_longitude_n     : this.store_currentUserGeoLocation_vc.val.ugl_longitude_n,
                    mpl_timestamp_t     : this.store_currentUserGeoLocation_vc.val.ugl_timestamp_t,
                    mpl_secondsForOld_n : 5,
                })
            },
            co_qb_clueCodes_as(){
               return this.server_questBody_c ? this.server_questBody_c.qb_cluesCodes_ac.map(clueCode_c => clueCode_c.qbcc_code_s) : []
            }
        },
        methods:{

            m_clickPolygon_f(index_n){
                if(this.server_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.polygons){
                    this.m_click_riddle_f(index_n)
                }
            },

            m_click_riddle_f(index_n){
                route_moveToRoute(enum_moveToOptions.ongoing_quest_openMap_riddle, {[enum_urlParams.riddleId_n]: index_n})
            },
            m_click_lastRiddles_f(){
                route_moveToRoute(enum_moveToOptions.ongoing_quest_openMap_lastRiddles)
            },
            m_checkClueCode_f(){

                let hiddenCodeIndex_n = this.co_qb_clueCodes_as.indexOf(this.userClueCode_s)
                let hiddenClue_c = this.server_questBody_c.qb_cluesCodes_ac[hiddenCodeIndex_n]

                // wrong code
                if(hiddenClue_c == null){
                    notification_notify(ass_strings.twoWords_wrongCode)
                    return
                }

                // used code
                if(this.server_teamStatus_c.ts_usedClues_as.includes(this.userClueCode_s) ){
                    notification_notify(ass_strings.twoWords_usedCode)
                    return
                }

                // find new hidden code
                this.server_teamStatus_c.ts_usedClues_as.push(this.userClueCode_s)
                serverOngoing_hiddenClue_update_f(this.store_ongoing_questEvent_v.val, this.server_teamStatus_c,this.server_questBody_c.qb_metadata_c.qbm_quest_hiddenCodesMode_e, hiddenCodeIndex_n, hiddenClue_c, () => {
                    this.showSearchClue_vb.val=false
                    notification_notify(ass_strings.threeWords_foundHiddenCode)

                })

            },
        },

        // life circle:
        created(){

            // 1) current user
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData) => {
                this.server_currentUserData_c = currentUserData
            })

            // 2) teamPlayerGeoLocations
            serverOngoing_teamPlayersGeoLocation_cl_set_f(this.$options.name, this.store_ongoing_questEvent_v.val, this.store_currentTeamId_uid,
                (userGeoLocation_c) => {

                    if( this.server_currentUserData_c != null &&
                        this.server_currentUserData_c.ud_userId_uid !== userGeoLocation_c.ugl_userId_uid){


                        // get user data
                        if(this.server_teamsPlayersData_byPlayerIdC[userGeoLocation_c.ugl_userId_uid] == null){

                            serverAuth_getOtherUserData_f(userGeoLocation_c.ugl_userId_uid,
                                userData_c => {
                                    this.$set(this.server_teamsPlayersData_byPlayerIdC, userGeoLocation_c.ugl_userId_uid, userData_c)
                                })

                        }else{

                            this.$set(this.server_mapPlayersLocations_byUserId_c, userGeoLocation_c.ugl_userId_uid, new FB_MapPlayerLocation({
                                mpl_userId_uid      : userGeoLocation_c.ugl_userId_uid,
                                mpl_username_s      : this.server_teamsPlayersData_byPlayerIdC[userGeoLocation_c.ugl_userId_uid].ud_name_s,
                                mpl_dotColor_s      : "green",
                                mpl_accuracy_n      : userGeoLocation_c.ugl_accuracy_n,
                                mpl_latitude_n      : userGeoLocation_c.ugl_latitude_n,
                                mpl_longitude_n     : userGeoLocation_c.ugl_longitude_n,
                                mpl_timestamp_t     : userGeoLocation_c.ugl_timestamp_t,
                                mpl_secondsForOld_n : 5,
                            }))

                        }
                    }



                })


            // 3) team status
            serverOngoing_teamStatus_vl_set_f({
                viewName_s: this.$options.name, 
                questEvent_c : this.store_ongoing_questEvent_v.val, 
                teamId_uid : this.store_currentTeamId_uid,
                cb_f: (teamStatus_c) => {
                    this.server_teamStatus_c = teamStatus_c
                }
            })


            // 4) get teamStatus subCollection riddles
            serverOngoing_teamStatus_subCollection_cl_get_f({
                viewName_s: this.$options.name,
                subCollectionName_e: enum_subCollection_teamStatus.MAP_MISSIONS,
                questEvent_c: this.store_ongoing_questEvent_v.val,
                teamId_uid: this.store_currentTeamId_uid,
                cb_ChildAdded_f : (riddleStatus_c) => {
                    this.$set(this.store_ongoing_teamStatus_riddles_byRiddleId_c, riddleStatus_c.rs_riddleId_n, riddleStatus_c)
                },
                cb_changeChild_f : (riddleStatus_c) => {
                    this.$set(this.store_ongoing_teamStatus_riddles_byRiddleId_c, riddleStatus_c.rs_riddleId_n, riddleStatus_c)
                }
            })

            // 5) get questBody
            serverBig_questBody_once_fp(this.store_ongoing_questEvent_v.val.qev_questType_e, this.store_ongoing_questEvent_v.val.qev_questId_uid, false, true,
                (questBody_c)=>{
                    this.displayLangForMap_e = questBody_c.cm_qb_getDisplayLangCode_e(this.store_system_langCode_v.val)
                    this.server_questBody_c = questBody_c
                })

        },
        activated(){
            // this.refreshMapCounter_n++
            if(this.server_questBody_c){
                this.displayLangForMap_e = this.server_questBody_c.cm_qb_getDisplayLangCode_e(this.store_system_langCode_v.val)
            }
        },
        destroyed(){

            // 1) current user
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            // 2) teamPlayerGeoLocation
            serverOngoing_teamPlayersGeoLocation_cl_remove_f(this.$options.name, this.store_ongoing_questEvent_v.val, this.store_currentTeamId_uid)

            // 3) teamPlayerGeoLocation
            serverOngoing_teamStatus_vl_remove_f(this.$options.name, this.store_ongoing_questEvent_v.val, this.store_currentTeamId_uid)

            // 4) teamStatus subCollection riddles
            serverOngoing_teamStatus_subCollection_cl_remove_f({
                viewName_s          : this.$options.name,
                subCollectionName_e : enum_subCollection_teamStatus.MAP_MISSIONS,
                questEvent_c        : this.store_ongoing_questEvent_v,
                teamId_uid          : this.store_currentTeamId_uid,
            })

        }
    }

</script>

<style scoped lang="scss">

    .lc_root{
        position: relative;
    }

    .lc_finishRiddle{
        position: fixed;
        bottom: calc(var(--bottomBar) + 8px);
        left: 8px;
    }





</style>